import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table18Data = { [key: string]: Table18Row };

export interface ITable18Props {
  data: Table18Data;
}

interface ITable18State {
}

interface Table18Row {
  totalAll: number;
  totalFatal: number;
  mondayAll: number;
  mondayFatal: number;
  tuesdayAll: number;
  tuesdayFatal: number;
  wednesdayAll: number;
  wednesdayFatal: number;
  thursdayAll: number;
  thursdayFatal: number;
  fridayAll: number;
  fridayFatal: number;
  saturdayAll: number;
  saturdayFatal: number;
  sundayAll: number;
  sundayFatal: number;
}

const sortOrder = [
  "Midnight to 2:59",
  "3:00-5:59 AM",
  "6:00-8:59 AM",
  "9:00-11:59 AM",
  "12:00-2:59 PM",
  "3:00-5:59 PM",
  "6:00-8:59 PM",
  "9:00-11:59 PM",
  "Not Stated/Unknown",
  "TOTALS",
];

export default class Table18Summary extends React.Component<ITable18Props, ITable18State> {
  constructor(props: ITable18Props) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      <React.Fragment>
        {this.props.data ?
          <table className="ss-table summaryTable1">
            <colgroup>
              <col style={{ width: 210 }} />
            </colgroup>
            <thead>
              <tr>
                <th rowSpan={2} className="border-right-bold">
                  <div className="ss-table-header">
                    <span className="header-number">18</span>
                    <span className="header-text">TIME OF CRASH</span>
                  </div>
                </th>
                <th colSpan={2}>TOTAL</th>
                <th colSpan={2}>MONDAY</th>
                <th colSpan={2}>TUESDAY</th>
                <th colSpan={2}>WEDNESDAY</th>
                <th colSpan={2}>THURSDAY</th>
                <th colSpan={2}>FRIDAY</th>
                <th colSpan={2}>SATURDAY</th>
                <th colSpan={2}>SUNDAY</th>
              </tr>
              <tr>
                <th>ALL</th>
                <th>FATAL</th>
                <th>ALL</th>
                <th>FATAL</th>
                <th>ALL</th>
                <th>FATAL</th>
                <th>ALL</th>
                <th>FATAL</th>
                <th>ALL</th>
                <th>FATAL</th>
                <th>ALL</th>
                <th>FATAL</th>
                <th>ALL</th>
                <th>FATAL</th>
                <th>ALL</th>
                <th>FATAL</th>
              </tr>
            </thead>
            <tbody>
              {sortBasedOnList(this.props.data, sortOrder).map((key) =>
                <tr key={key} className={key === "TOTALS" ? "border-bold bold-text" : null}>
                  <td className="border-right-bold">{key}</td>
                  <td className="numberTotals">{this.props.data[key].totalAll}</td>
                  <td className="numberTotals">{this.props.data[key].totalFatal}</td>
                  <td className="numberTotals">{this.props.data[key].mondayAll}</td>
                  <td className="numberTotals">{this.props.data[key].mondayFatal}</td>
                  <td className="numberTotals">{this.props.data[key].tuesdayAll}</td>
                  <td className="numberTotals">{this.props.data[key].tuesdayFatal}</td>
                  <td className="numberTotals">{this.props.data[key].wednesdayAll}</td>
                  <td className="numberTotals">{this.props.data[key].wednesdayFatal}</td>
                  <td className="numberTotals">{this.props.data[key].thursdayAll}</td>
                  <td className="numberTotals">{this.props.data[key].thursdayFatal}</td>
                  <td className="numberTotals">{this.props.data[key].fridayAll}</td>
                  <td className="numberTotals">{this.props.data[key].fridayFatal}</td>
                  <td className="numberTotals">{this.props.data[key].saturdayAll}</td>
                  <td className="numberTotals">{this.props.data[key].saturdayFatal}</td>
                  <td className="numberTotals">{this.props.data[key].sundayAll}</td>
                  <td className="numberTotals">{this.props.data[key].sundayFatal}</td>
                </tr>
              )}
            </tbody>
          </table>
          : <p>Loading...</p>}
      </React.Fragment>
    );
  }
}
